module.exports = __webpack_public_path__ + "img/ic-favorites-active.bca33822.svg";